import { render, staticRenderFns } from "./compras.vue?vue&type=template&id=585e2a7c&scoped=true"
import script from "./compras.vue?vue&type=script&lang=js"
export * from "./compras.vue?vue&type=script&lang=js"
import style0 from "./compras.vue?vue&type=style&index=0&id=585e2a7c&prod&lang=css"
import style1 from "./compras.vue?vue&type=style&index=1&id=585e2a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e2a7c",
  null
  
)

export default component.exports